import $ from 'jquery';
import ShareModal from 'ui/share/modal.js';

$(() => {
    $('#main_footer').on('click', '.js-share', (e) => {
        if (!e.target) {
            return;
        }

        const url = e.target.getAttribute('data-url');
        const shareModal = new ShareModal(url, {
            title: 'Поделиться страницей',
        });

        shareModal.show();
    });
});
